import bankApi from '../../../../api/bank';
import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';

const defaultState = () => ({
  listBank : []
});

const state = defaultState();

const actions = {
	getBank({ commit, dispatch }, param ) {
		commit(PROGRESS_START, null, { root: true });

		bankApi.bankAccount(param).then(({ data: { data } }) => {
			commit('definelistBank', data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
}

const mutations = {
	definelistBank(state, data) {
		state.listBank = [... data]
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};